export default "__VITE_ASSET__B3C91jPY__"